import { render, staticRenderFns } from "./idseal.vue?vue&type=template&id=77bc5351&"
import script from "./idseal.vue?vue&type=script&lang=js&"
export * from "./idseal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports